import { deadlineReminderTone } from "@tribunalea/shared";

function timestamp(value) {
  if (!value) return 0;
  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
}

function dueDateValue(reminder) {
  const value = String(reminder?.dueDate || "").trim();
  return /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? value
    : null;
}

export function isDangerReminder(reminder, now = new Date()) {
  return deadlineReminderTone(reminder, { now }) === "danger";
}

export function isDangerExpediente(expediente, now = new Date()) {
  if (Object.prototype.hasOwnProperty.call(expediente || {}, "trafficColor")) {
    return expediente.trafficColor === "red";
  }
  return isDangerReminder(expediente?.procedureState?.nextReminder, now);
}

export function compareExpedienteCards(left, right) {
  const leftReminder = left.procedureState?.nextReminder;
  const rightReminder = right.procedureState?.nextReminder;
  const leftDanger = isDangerExpediente(left);
  const rightDanger = isDangerExpediente(right);

  if (leftDanger !== rightDanger) return leftDanger ? -1 : 1;

  if (leftDanger && rightDanger) {
    const leftDueDate = dueDateValue(leftReminder);
    const rightDueDate = dueDateValue(rightReminder);
    if (leftDueDate && rightDueDate && leftDueDate !== rightDueDate) {
      return leftDueDate.localeCompare(rightDueDate);
    }
    if (leftDueDate !== rightDueDate) return leftDueDate ? -1 : 1;
  }

  const activityDifference =
    timestamp(right.lastActivityAt) - timestamp(left.lastActivityAt);
  if (activityDifference) return activityDifference;

  const addedDifference = timestamp(right.addedAt) - timestamp(left.addedAt);
  if (addedDifference) return addedDifference;

  return String(left.cuij || "").localeCompare(String(right.cuij || ""));
}
